import { render, staticRenderFns } from "./Site_Info.vue?vue&type=template&id=dd5b96ba&scoped=true&"
import script from "./Site_Info.vue?vue&type=script&lang=js&"
export * from "./Site_Info.vue?vue&type=script&lang=js&"
import style0 from "./Site_Info.vue?vue&type=style&index=0&id=dd5b96ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5b96ba",
  null
  
)

export default component.exports